import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { styled } from "@mui/material/styles";

type HealthPlaceProfileTextProps = {
  primary: string;
};

export const LoginContent = styled("div")<HealthPlaceProfileTextProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 0;
  background-color: ${(props) => props.primary};
  @media (max-height: 800px) {
    height: 110vh;
  }
  @media (max-width: 700px) {
    padding: 0 10px;
  }
`;

export const LoginDiv = styled("div")`
  background-color: #fafafa;
  border-radius: 6px;
  height: 400px;
  width: 100%;
  max-width: 541px;
  /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */
  margin-top: 40px;
  position: relative;
`;

export const LoginH2 = styled("h2")`
  color: #0d0d0d;
  font-weight: 800;
  font-size: 24px;
  padding-bottom: 9px;
`;

export const DivFormLogin = styled("form")`
  align-items: center;
  padding: 37px;

  @media (max-width: 700px) {
    padding: 37px 20px;
  }
`;

export const LoginFormControl = styled(FormControl)`
  width: 100%;
`;

export const LoginInputLabel = styled(InputLabel)`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #717171;
`;

export const LoginOutlinedInput = styled(OutlinedInput)`
  background-color: #ffffff;
  border-radius: 6px;
`;
export const LoginInputAdornment = styled(InputAdornment)``;

export const LoginIconButton = styled(IconButton)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #717171;
`;

export const LoginContentButton = styled("div")`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`;

export const LoginButton = styled("button")`
  border: none;
  margin-top: 15px;
  width: 100%;
  background: #ffbb00;
  border-top: 15px solid #ffbb00;
  border-bottom: 15px solid #ffbb00;
  border-radius: 6px;
  background-color: #ffbb00;
  box-shadow: rgba(50, 50, 93, 0.1) 0px 4px 6px 0px,
    rgba(0, 0, 0, 0.08) 0px 1px 3px 0px;
  border-radius: 6px;
  cursor: pointer;

  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: #1f1f1f;
  &:disabled {
    background-color: #ffbb00;
    border-top: 15px solid #ffbb00;
    border-bottom: 15px solid #ffbb00;
    cursor: not-allowed;
  }
  &:hover {
    background-color: #b68500;
    border-top: 15px solid #b68500;
    border-bottom: 15px solid #b68500;
  }
`;

export const LoginContentA = styled("div")`
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
`;

export const LoginA = styled("a")`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  text-align: center;
  text-decoration-line: underline;

  color: #717171;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: #00da8c;
  }
`;

export const LoginLogoContent = styled("div")`
  width: 100%;
  display: flex;
  justify-content: center;

  @media (max-width: 700px) {
    padding-top: 20px;
  }

  @media (max-width: 400px) {
    img {
      width: 200px;
    }
    padding-top: 20px;
  }
`;

export const LoginInputError = styled("span")`
  color: red;
`;

export const LoginInputMensagem = styled("span")`
  color: #717171;
  font-size: 0.8rem;
`;

export const LoginPBlack = styled("span")`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #717171;
`;
